<template>
  <v-container id="bid-specification" fluid tag="section" class="main-container">
    <idc-component-bid-specification
      :settings="settings"
      :can-edit="false"
      :can-read="canRead"
      :can-delete="false"
      :can-clone="true"
      :can-submit-bid="false"
      :can-remove-comments="canRemoveComments"
      :url-paper-work="urlPaperWork"
      :url-equipment="urlEquipment"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import Path from '@/utilities/bid/enums/Path'

  export default Vue.extend({
    name: 'DashboardInactiveBidSpecification',
    components: {
      IdcComponentBidSpecification: () => import('@/components/idc/bids/Specification.vue'),
    },
    props: {
      canRead: {
        type: Boolean,
        default: () => true,
      },
      canRemoveComments: {
        type: Boolean,
        default: () => false,
      },
      urlPaperWork: {
        type: String,
        default: () => Path.SALES_NO_BIDS_PAPERWORK,
      },
      urlEquipment: {
        type: String,
        default: () => Path.SALES_NO_BIDS_EQUIPMENT,
      },
    },
    computed: {
      ...mapState('Settings', ['settings']),
    },
  })
</script>
